export const PAGE_HEADER_LABELS = {
	TITLE: 'Platform Label Management',
	SUBTITLE: 'Manage the labels used across the platform to categorize your data.',
	CREATE_BUTTON: 'Create Label'
} as const;
